import React from "react";
import { Box, Grid } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";

import MobileFilterButton from "./MobileFilterButton";
import Boards from "../../components/Filters/Boards";
import DrawerGlobalComp from "../../../../components/Drawer";
import GlobalSearch from "../../../../components/Search";
import Status from "./Status";
import Team from "../../components/Filters/Team";
import ToggleInput from "../../../../components/ToggleInput";
import { CustomButton } from "../../../../components/Button/Button";
import { useGroupingHeaderState } from "../../hooks/useGroupingHeaderState";

const Header = React.memo(({ teams, groupingUserFromRedux }) => {
  const {
    clearFilters,
    closeFilterDrawer,
    filterDrawer,
    filteredUser,
    handleApplyFilter,
    handleChange,
    handleOpenSearchField,
    handleVisibilityChange,
    inputValue,
    isMobile,
    isVisible,
    oldBoard,
    oldDate,
    openFilterDrawer,
    openSearchField,
  } = useGroupingHeaderState(groupingUserFromRedux);

  return (
    <div>
      {!isMobile && (
        <div className="d-flex">
          <p className="board-heading-name">Task Assignments</p>
          <Status setIsVisible={() => handleVisibilityChange(true)} />
        </div>
      )}
      {isMobile ? (
        openSearchField ? (
          <Grid
            container
            item
            xs={12}
            className="remove-container-width fixed-ui"
            justifyContent={"center"}
            alignItems={"center"}>
            <GlobalSearch
              placeholder={"Search..."}
              searchText={inputValue}
              handleChange={handleChange}
              onCancel={handleOpenSearchField}
              showCancel={true}
              fullWidth={true}
            />
          </Grid>
        ) : (
          <MobileFilterButton
            setFilterDrawer={openFilterDrawer}
            handleOpenSearchField={handleOpenSearchField}
          />
        )
      ) : (
        <div className="d-flex align-items-center mt-1 mb-2">
          <ToggleInput value={isVisible} setValue={handleVisibilityChange} />
          <div className={`slide-panel d-flex ${isVisible ? "open" : ""}`}>
            <Team team={teams} />
            <Boards />
            <div className="ml-4">
              <GlobalSearch
                placeholder={"Search..."}
                searchText={inputValue}
                handleChange={handleChange}
              />
            </div>
          </div>
        </div>
      )}
      {filterDrawer && (
        <DrawerGlobalComp open={filterDrawer} setOpen={closeFilterDrawer}>
          <Box>
            <div className="filter-head-container">
              <p className="filter-head-mobile">Filter By</p>
              {(oldBoard || filteredUser.length > 0 || oldDate) && (
                <div
                  className="d-flex align-items-center"
                  onClick={clearFilters}>
                  <ReplayIcon className="reset-mobile-icon" />
                  <p className="reset-text-mobile">Reset</p>
                </div>
              )}
            </div>
            <div className="filter-body-container">
              <div className="mt-4">
                <Team team={teams} />
              </div>

              <div className="mt-4">
                <Boards />
              </div>
            </div>

            <CustomButton
              className=" capitalize mobile-board-filter-apply-btn"
              variant="outlined"
              onClick={handleApplyFilter}>
              Apply
            </CustomButton>
          </Box>
        </DrawerGlobalComp>
      )}
    </div>
  );
});

export default Header;
